import { breaking, hotKeywords } from "@/mocks/data";

export default function HeroSection() {
  return (
    <section id="top" className="relative">
      <div className="mx-auto w-full max-w-7xl px-4 pt-6 md:px-6">
        {/* ticker */}
        <div className="mb-5 flex items-center gap-3 overflow-hidden rounded-md border border-background-200 bg-background-50 px-4 py-2.5">
          <span className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-bold uppercase tracking-wider text-primary-700">
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" />
            </span>
            滚动快讯
          </span>
          <div className="min-w-0 flex-1 overflow-hidden">
            <p className="truncate text-sm text-foreground-700">
              正在跟进 8 起近期事件 · 累计发布 218 条进展动态 · 今日新增 5 条新料
            </p>
          </div>
          <span className="hidden whitespace-nowrap text-xs text-foreground-400 sm:block">
            更新于 09-09 10:24
          </span>
        </div>

        {/* breaking card */}
        <div className="overflow-hidden rounded-xl border border-background-200 bg-foreground-950">
          <div className="grid lg:grid-cols-2">
            <div className="flex flex-col justify-center p-7 md:p-10 lg:p-12">
              <div className="mb-4 inline-flex w-fit items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-background-50">
                <i className="ri-alarm-warning-line text-sm" />
                头条 · 持续跟进
              </div>
              <h1 className="font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
                {breaking.title}
              </h1>
              <p className="mt-4 text-sm leading-relaxed text-foreground-200 md:text-base">
                {breaking.excerpt}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <a
                  href="#timeline"
                  className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
                >
                  查看时间线复盘
                  <i className="ri-arrow-right-line" />
                </a>
                <a
                  href="#latest"
                  className="inline-flex whitespace-nowrap items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-100 hover:text-foreground-950"
                >
                  围观最新进展
                </a>
              </div>
            </div>
            <div className="relative min-h-[260px] lg:min-h-full">
              <img
                src={breaking.cover}
                alt={breaking.title}
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/30 to-transparent" />
            </div>
          </div>
        </div>

        {/* hot keywords */}
        <div className="mt-5 flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-500">
            <i className="ri-fire-line text-primary-600" />
            热门关键词
          </span>
          {hotKeywords.map((k) => (
            <a
              key={k}
              href="#latest"
              className="inline-flex whitespace-nowrap items-center rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              #{k}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}